import ProductPurchase from "../../components/productPurchase";

const customSelect = {
  app: function (parent, originalParent) {
    if (parent.classList.contains('done')) return;

    const elSelectNative = parent.getElementsByClassName("js-selectNative")[0];
    const elSelectCustom = parent.getElementsByClassName("js-selectCustom")[0];

    if (elSelectNative && elSelectCustom) {
      var elSelectCustomBox = elSelectCustom.children[0];
      var elSelectCustomOpts = elSelectCustom.children[1];
      var customOptsList = Array.from(elSelectCustomOpts.children);
      var optionsCount = customOptsList.length;
      var defaultLabel = elSelectCustomBox.getAttribute("data-value");

      var optionChecked = "";
      var optionHoveredIndex = -1;

      elSelectCustomBox.removeEventListener("click", handleClick);

      // Toggle custom select visibility when clicking the box
      elSelectCustomBox.addEventListener("click", handleClick);
    }

    function handleClick() {
      const isClosed = !elSelectCustom.classList.contains("isActive");

      if (isClosed) {
        openSelectCustom();
      } else {
        closeSelectCustom();
      }
    }

    function openSelectCustom() {
      elSelectCustom.classList.add("isActive");
      // Remove aria-hidden in case this was opened by a user
      // who uses AT (e.g. Screen Reader) and a mouse at the same time.
      elSelectCustom.setAttribute("aria-hidden", false);

      if (optionChecked) {
        const optionCheckedIndex = customOptsList.findIndex(
          (el) => el.getAttribute("data-value") === optionChecked
        );
        updateCustomSelectHovered(optionCheckedIndex);
      }

      // Add related event listeners
      window.addEventListener("click", watchClickOutside);
      window.addEventListener("keydown", supportKeyboardNavigation);
    }

    function closeSelectCustom() {
      elSelectCustom.classList.remove("isActive");

      elSelectCustom.setAttribute("aria-hidden", true);

      updateCustomSelectHovered(-1);

      // Remove related event listeners
      window.removeEventListener("click", watchClickOutside);
      window.removeEventListener("keydown", supportKeyboardNavigation);
    }

    function updateCustomSelectHovered(newIndex) {
      const prevOption = elSelectCustomOpts.children[optionHoveredIndex];
      const option = elSelectCustomOpts.children[newIndex];

      if (prevOption) {
        prevOption.classList.remove("isHover");
      }
      if (option) {
        option.classList.add("isHover");
      }

      optionHoveredIndex = newIndex;
    }

    function updateCustomSelectChecked(value, text, originalParent) {
      const prevValue = optionChecked;

      const elPrevOption = elSelectCustomOpts.querySelector(
        `[data-value="${prevValue}"`
      );
      const elOption = elSelectCustomOpts.querySelector(`[data-value="${value}"`);

      if (elPrevOption) {
        elPrevOption.classList.remove("isActive");
      }

      if (elOption) {
        elOption.classList.add("isActive");
      }

      elSelectCustomBox.innerHTML = text;
      optionChecked = value;

      // TRIGGER CLICK TO UPDATE PRODUCT SKU
      originalParent.querySelector(`[data-attribute-value="${value}"]`).click();

      // console.dir(elOption)
      // console.log("originalParent", originalParent);

      if (elOption.hasAttribute('data-product-attribute')) {
        originalParent.querySelector(`option[data-attribute-value="${value}"]`).selected = true;

        ProductPurchase.checkSelection(originalParent);
      }
    }

    function watchClickOutside(e) {
      const didClickedOutside = !elSelectCustom.contains(e.target);
      if (didClickedOutside) {
        closeSelectCustom();
      }
    }

    function supportKeyboardNavigation(e) {
      // press down -> go next
      if (e.keyCode === 40 && optionHoveredIndex < optionsCount - 1) {
        let index = optionHoveredIndex;
        e.preventDefault(); // prevent page scrolling
        updateCustomSelectHovered(optionHoveredIndex + 1);
      }

      // press up -> go previous
      if (e.keyCode === 38 && optionHoveredIndex > 0) {
        e.preventDefault(); // prevent page scrolling
        updateCustomSelectHovered(optionHoveredIndex - 1);
      }

      // press Enter or space -> select the option
      if (e.keyCode === 13 || event.keyCode === 32) {
        e.preventDefault();

        const option = elSelectCustomOpts.children[optionHoveredIndex];
        const value = option && option.getAttribute("data-value");

        if (value) {
          elSelectNative.value = value;
          updateCustomSelectChecked(value, option.innerHTML, originalParent);
        }
        closeSelectCustom();
      }

      // press ESC -> close selectCustom
      if (e.keyCode === 27) {
        closeSelectCustom();
      }
    }

    if (elSelectNative) {
      // Update selectCustom value when selectNative is changed.
      elSelectNative.addEventListener("change", (e) => {

        const value = e.target.value;
        const elRespectiveCustomOption = elSelectCustomOpts.querySelectorAll(
          `[data-value="${value}"]`
        )[0];

        updateCustomSelectChecked(value, elRespectiveCustomOption.innerHTML, originalParent);
      });
    }

    // Update selectCustom value when an option is clicked or hovered
    if (customOptsList) {
      const customEvent = new Event('change');

      customOptsList.forEach(function (elOption, index) {
        elOption.addEventListener("click", (e) => {
          const value = e.target.getAttribute("data-value");

          // Sync native select to have the same value
          elSelectNative.value = value;
          updateCustomSelectChecked(value, e.target.innerHTML, originalParent);
          closeSelectCustom();

          elSelectNative.dispatchEvent(customEvent);
        });

        elOption.addEventListener("mouseenter", (e) => {
          updateCustomSelectHovered(index);
        });

      });
    }
  },

  init: function (parent) {
    const originalParent = parent;
    const selectWrappers = parent ? parent.querySelectorAll('.selectWrapper') : document.querySelectorAll('.selectWrapper');

    // console.log('selectWrappers: ', selectWrappers);
    // console.log("originalParent", originalParent);

    selectWrappers.forEach(item => {
      customSelect.app(item, originalParent);
      item.classList.add('done');
    })
  }
}

export default customSelect;
